import React, { useEffect, useState, useCallback } from 'react';
import { Button, Input, Typeahead } from '../../../components';
import { useProductGroup } from '../../../context/ProductGroupContext/ProductGroupContextProvider';

const CreateProductGroup = ({ closeModal, data }) => {
  const {
    productGroup,
    setProductGroup,
    getSalesDepartment,
    error,
    salesDepartmentResponse,
    powerBiMainProductGroupResponse,
    mainProductGroupResponse,
    createNewSalesDepartment,
    createMainProductGroup,
    createPowerBiMainProductGroup,
    getPowerBiMainProductGroup,
    getMainProductGroup,
    createProductGroup,
    updateProductGroup,
  } = useProductGroup();
  const [closeError, setCloseError] = useState(false);
  const [selectedSalesDepartment, setSelectedSalesDepartment] = useState(
    productGroup?.salesDepartment?.id ? [productGroup.salesDepartment] : [],
  );
  const [selectedMainProductGroup, setSelectedMainProductGroup] = useState(
    productGroup?.mainProductGroup?.id ? [productGroup.mainProductGroup] : [],
  );
  const [selectedPowerBiMainProductGroup, setSelectedPowerBiMainProductGroup] =
    useState(
      productGroup?.powerBiMainProductGroup?.id
        ? [productGroup.powerBiMainProductGroup]
        : [],
    );

  const [salesDepartmentQuery, setSalesDepartmentQuery] = useState('');
  const [mainProductGroupQuery, setMainProductGroupQuery] = useState('');
  const [powerBiMainProductGroupQuery, setPowerBiMainProductGroupQuery] =
    useState('');

  const [errFlag, setErrFlag] = useState(false);

  useEffect(() => {
    getSalesDepartment();
    getPowerBiMainProductGroup();
    getMainProductGroup();
    setCloseError(false);
  }, []);

  useEffect(() => {
    if (data) {
      setProductGroup(data);
      setSelectedSalesDepartment(
        data.salesDepartment.id ? [data.salesDepartment] : [],
      );
      setSelectedMainProductGroup(
        data.mainProductGroup.id ? [data.mainProductGroup] : [],
      );
      setSelectedPowerBiMainProductGroup(
        data.powerBiMainProductGroup.id ? [data.powerBiMainProductGroup] : [],
      );
    }
  }, [data]);

  const handleInputChange = useCallback((e) => {
    const { name, value } = e.target;
    setProductGroup((prev) => ({ ...prev, [name]: value }));
  }, []);

  const handleTypeaheadChange = useCallback(
    (field, setSelected, setQuery) => (selectedOptions) => {
      const selectedOption = selectedOptions[0];
      setSelected(selectedOptions);
      setProductGroup((prev) => ({
        ...prev,
        [field]: selectedOption,
        // ? {
        //     id: selectedOption.id,
        //     [`${field}Name`]: selectedOption[`${field}Name`],
        //   }
        // : null,
      }));
      setQuery(selectedOption ? selectedOption[`${field}Name`] : '');
    },
    [],
  );

  const handleTypeaheadBlur = useCallback(
    (field, setSelected, setQuery, query, response) => (e) => {
      if (query || setSelected[field] == query) {
        setSelected([]);
        setQuery('');
        setProductGroup((prev) => ({ ...prev, [field]: null }));
      }
    },
    [],
  );

  const handleCreateNew = useCallback(
    (createFunction, setSelected) => async (query) => {
      const newObject = await createFunction(query);
      if (newObject) {
        setSelected([newObject]); // Update local state
        setProductGroup((prev) => ({
          // Update context form state
          ...prev,
          [newObject.id]: newObject, // Use the new object directly
        }));
      }
    },
    [setProductGroup],
  );

  const submitForm = useCallback(
    async (productGroup, e) => {
      if (productGroup.id > 0) {
        await updateProductGroup(productGroup, productGroup.id, e, closeModal);
      } else {
        await createProductGroup(productGroup, e, closeModal);
      }
    },
    [updateProductGroup, createProductGroup, closeModal],
  );

  return (
    <form onSubmit={(e) => submitForm(productGroup, e)}>
      <div className="lg:grid grid-cols-2 gap-5 items-center lg:w-[600px]">
        <div>
          <Input
            name="productGroupCode"
            type="text"
            disabled={productGroup?.id}
            label="Product Group Code"
            placeholder="Enter Product Group Code"
            value={productGroup.productGroupCode}
            onChange={handleInputChange}
            error={error?.productGroupCode}
            required
          />
        </div>
        <div>
          <Input
            name="productGroupName"
            type="text"
            label="Product Group Name"
            placeholder="Enter Product Group Name"
            value={productGroup.productGroupName}
            onChange={handleInputChange}
            error={error?.productGroupName}
            required
          />
        </div>
        <div>
          <Input
            name="catalogueNo"
            type="text"
            label="Catalogue No"
            placeholder="Enter Catalogue No"
            value={productGroup.catalogueNo}
            onChange={handleInputChange}
            error={error?.catalogueNo}
            required
          />
        </div>
        <div>
          <Typeahead
            id="salesDepartment"
            label="Sales Department"
            disabled={productGroup?.id}
            labelKey="salesDepartmentName"
            options={salesDepartmentResponse}
            placeholder="Choose Sales Department"
            onChange={handleTypeaheadChange(
              'salesDepartment',
              setSelectedSalesDepartment,
              setSalesDepartmentQuery,
            )}
            onBlur={handleTypeaheadBlur(
              'salesDepartment',
              setSelectedSalesDepartment,
              setSalesDepartmentQuery,
              salesDepartmentQuery,
              salesDepartmentResponse,
            )}
            custErr={error.salesDepartment}
            checkErr={errFlag}
            query={salesDepartmentQuery}
            setQuery={setSalesDepartmentQuery}
            selected={selectedSalesDepartment}
            isInvalid={!error?.salesDepartment}
            required
            createNewLabel="Create new"
            closeError={closeError}
            handleCreateNew={handleCreateNew(createNewSalesDepartment)}
          />
          {/* {error?.salesDepartment && (
            <div
              className="text-red-600 text-break px-1 h-4 font-semibold font-400"
              style={{
                fontSize: "13px",
                height: "20px",
                display: error ? "block" : "none",
              }}
            >
              {error.salesDepartment}
            </div>
          )} */}
        </div>
        <div>
          <Typeahead
            id="mainProductGroup"
            label="Main Product Group"
            labelKey="mainProductGroupName"
            disabled={productGroup?.id}
            options={mainProductGroupResponse}
            placeholder="Choose  Main Product Group"
            onChange={handleTypeaheadChange(
              'mainProductGroup',
              setSelectedMainProductGroup,
              setMainProductGroupQuery,
            )}
            onBlur={handleTypeaheadBlur(
              'mainProductGroup',
              setSelectedMainProductGroup,
              setMainProductGroupQuery,
              mainProductGroupQuery,
              mainProductGroupResponse,
            )}
            checkErr={errFlag}
            custErr={error.mainProductGroup}
            query={mainProductGroupQuery}
            setQuery={setMainProductGroupQuery}
            selected={selectedMainProductGroup}
            isInvalid={!error?.mainProductGroup}
            required
            createNewLabel="Create new"
            handleCreateNew={handleCreateNew(
              createMainProductGroup,
              setSelectedMainProductGroup,
            )}
            closeError={closeError}
          />
          {/* {error?.mainProductGroup && (
            <div
              className="text-red-600 text-break px-1 h-4 font-semibold font-400"
              style={{
                fontSize: "13px",
                height: "20px",
                display: error ? "block" : "none",
              }}
            >
              {error.mainProductGroup}
            </div>
          )} */}
        </div>
        <div>
          <Typeahead
            id="powerBiMainProductGroup"
            label="Power BI Main Product Group"
            disabled={productGroup?.id}
            labelKey="powerBiMainProductGroupName"
            options={powerBiMainProductGroupResponse}
            placeholder="Choose Power BI Product Group"
            closeError={closeError}
            checkErr={errFlag}
            onChange={handleTypeaheadChange(
              'powerBiMainProductGroup',
              setSelectedPowerBiMainProductGroup,
              setPowerBiMainProductGroupQuery,
            )}
            onBlur={handleTypeaheadBlur(
              'powerBiMainProductGroup',
              setSelectedPowerBiMainProductGroup,
              setPowerBiMainProductGroupQuery,
              powerBiMainProductGroupQuery,
              powerBiMainProductGroupResponse,
            )}
            custErr={error.powerBiMainProductGroup}
            query={powerBiMainProductGroupQuery}
            setQuery={setPowerBiMainProductGroupQuery}
            selected={selectedPowerBiMainProductGroup}
            isInvalid={!error?.powerBiMainProductGroup}
            required
            createNewLabel="Create new"
            handleCreateNew={handleCreateNew(
              createPowerBiMainProductGroup,
              setSelectedPowerBiMainProductGroup,
            )}
          />
          {/* {error?.powerBiMainProductGroup && (
            <div
              className="text-red-600 text-break px-1 h-4 font-semibold font-400"
              style={{
                fontSize: "13px",
                height: "20px",
                display: error ? "block" : "none",
              }}
            >
              {error.powerBiMainProductGroup}
            </div>
          )} */}
        </div>
        <div className="flex justify-start gap-2 mt-10 m-2">
          <Button type="button" className="secondary" onClick={closeModal}>
            Cancel
          </Button>
          <Button
            type="submit"
            className="px-4 py-2 bg-yellow-500 text-white rounded-3xl">
            {data ? 'Update' : 'Save'}
          </Button>
        </div>
      </div>
    </form>
  );
};

export default CreateProductGroup;
